import { DocumentType } from '../../../enums/document-type';
import { batchPickList } from '../document-type-epic-helpers/batch-pick-list';
import * as Api from '../print.api';
import { jobRunner } from './job-runner';

/**
 * @typedef {import('./print-job-factory').PrintJob} PrintJob
 */

/**
 * @param {object} args
 * @param {string[]} args.fulfillmentPlanSetIds
 * @param {object} args.printer
 * @param {number} args.documentCount
 * @returns {import('rxjs').Observable<PrintJob>}
 */
export const createBatchPickListsAsync = ({ fulfillmentPlanSetIds, printer, documentCount }) => {
  const notification = batchPickList.getAsyncPrintStartedNotificationProps(documentCount);
  const errorNotification = batchPickList.getAsyncPrintFailedNotificationProps(documentCount);

  return jobRunner({
    apiRequest: () => Api.generateBatchPickListAsync(fulfillmentPlanSetIds),
    documentCount,
    documentTypeIdentifier: DocumentType.BatchPickList.identifier,
    initialNotification: notification,
    errorNotification,
    ids: fulfillmentPlanSetIds,
    printer,
  });
};
